import React from 'react';

import Container from '@src/components/Shared/Container';
import InlineSVG from '@src/components/Shared/InlineSVG';
import NextImage from '@src/components/Shared/NextImage';

import { HeroValdProdPropTypes } from './HeroValdProd.types';

const HeroValdProd: React.FC<HeroValdProdPropTypes> = ({
  ctfData,
  className,
  id,
  children,
  logoClassName,
  imgClassName,
  introClassName,
  headerClassName,
}) => {
  return (
    <Container
      attr='vald-hero-prod-component'
      id={id}
      className={`relative mt-[6.5rem] flex flex-col md:min-h-[50rem] md:flex-row md:items-center md:justify-between ${className}`}
    >
      <header className={headerClassName}>
        <h1 className='absolute invisible'>{ctfData?.title}</h1>
        {ctfData?.logo?.url && (
          <InlineSVG
            className={`mb-[2.4rem] mt-[3rem] max-w-[27.6386rem] xsm:min-h-[5.3219rem] md:mt-[4.1rem] md:min-h-[4.9484rem] md:max-w-[25.7rem] lg:min-h-[6.9188rem] lg:max-w-[35.9302rem] 2xl:min-h-[10.3906rem] 2xl:max-w-[53.96rem] ${logoClassName}`}
            src={ctfData?.logo?.url}
            renderAt={['desktop', 'tablet', 'mobile']}
          />
        )}

        <p className={introClassName}>
          {ctfData?.bodyCopy?.json?.content[0]?.content.map((p: any) => {
            if (p?.marks[0]?.type === 'bold') {
              return (
                <strong key={p?.value} className='font-medium text-primary'>
                  {p?.value}
                </strong>
              );
            }
            return p?.value;
          })}
        </p>
        {children}
      </header>

      <NextImage
        className={`${imgClassName}`}
        src={ctfData?.mediaPrimary?.url}
        alt={ctfData?.mediaPrimary?.description ?? '...'}
        width={ctfData?.mediaPrimary?.width}
        aspectRatio={ctfData?.mediaPrimary?.height}
      />
    </Container>
  );
};

export default HeroValdProd;
